import { render } from "./VueSelect.vue?vue&type=template&id=792409e0&scoped=true"
import script from "./VueSelect.vue?vue&type=script&lang=js"
export * from "./VueSelect.vue?vue&type=script&lang=js"

import "./VueSelect.vue?vue&type=style&index=0&id=792409e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792409e0"]])

export default __exports__